import React, { FC } from 'react'
import { backURL } from '../../consts'
import styles from './cart.module.css'
import { useAppDispatch } from '../../hooks/redux'
import { removeProductFromCart, ICartItem } from '../../features/cart/cartSlice'
import CartActions from '../CartActions/CartActions'
import { TbCurrencyDram } from 'react-icons/tb'

const NO_PHOTO = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Crect width='100' height='100' fill='%23f4f4f2'/%3E%3C/svg%3E"
const fmt = (n: number) => n.toLocaleString('ru-RU')

const CartItem: FC<{
    cartProduct: { cartItem: ICartItem; product_type: string }
}> = ({ cartProduct }) => {
    const { cartItem, product_type } = cartProduct
    const dispatch = useAppDispatch()

    const { brand, detail_number, model, price_original, price_copy, discount, imgs, img } = cartItem.product

    const masterImg = img || imgs?.find(i => i.master)?.img || ''
    const imgSrc = masterImg ? `${backURL}/${masterImg}` : NO_PHOTO

    const unitPrice = product_type === 'original' ? price_original : price_copy
    const count     = product_type === 'original' ? cartItem.count_original : cartItem.count_copy
    let total = unitPrice * count
    if (discount) total -= Math.floor(discount / 100 * total)

    return (
        <tr className={styles.row}>
            <td>
                <div className={styles.product}>
                    <div className={styles.thumb}>
                        <img
                            src={imgSrc}
                            alt={model}
                            onError={e => { (e.target as HTMLImageElement).src = NO_PHOTO }}
                        />
                    </div>
                    <div>
                        <span className={styles.name}>{brand} {model}</span>
                        <span className={styles.part}>{detail_number}</span>
                    </div>
                </div>
            </td>
            <td className={styles.price_cell}>
                {fmt(unitPrice)}&nbsp;<TbCurrencyDram />
            </td>
            <td className={styles.discount_cell}>
                {discount ? <span className={styles.discount_badge}>-{discount}%</span> : <span className={styles.dash}>—</span>}
            </td>
            <td>
                <div className={styles.qty_wrap}>
                    <CartActions product={cartItem.product} productType={product_type} inCart={true} />
                </div>
            </td>
            <td className={styles.total_cell}>
                {fmt(total)}&nbsp;<TbCurrencyDram />
            </td>
            <td>
                <button
                    className={styles.remove_btn}
                    onClick={() => dispatch(removeProductFromCart({ product_id: cartItem.product.product_id, product_type }))}
                    aria-label="Remove"
                >
                    ×
                </button>
            </td>
        </tr>
    )
}

export default CartItem
